import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'performReconnection',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: [],
      selectedConn: -1
    }
  },
  created() {
    this.$root.$on('perform_reconnection_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        //this.appData = this.dataObj.appData;

        for (var i = 0; i < this.dataObj.appData.length; i++) {
          this.appData.push({
            idx: i,
            conn: this.dataObj.appData[i]
          })
        }
      });
    },
    onSelect(item) {
      if (item == null)
        this.selectedConn = -1;
      else
        this.selectedConn = item.conn;
    }
  },
}
